/**
 * Auth Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.4
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AccountResponse { 
    id: string;
    identifier?: string;
    role?: AccountResponse.RoleEnum;
    scopes?: Array<string>;
    clientId?: string;
}
export namespace AccountResponse {
    export type RoleEnum = 'MGMT' | 'CLIENT';
    export const RoleEnum = {
        MGMT: 'MGMT' as RoleEnum,
        CLIENT: 'CLIENT' as RoleEnum
    };
}